import React, { useState } from "react";
import { Form, Button, Table } from "semantic-ui-react";
import debounce from "lodash.debounce";

const VideosLinksForm = ({ videosLinks, setVideosValues }) => {
	const [videos, setVideos] = useState(videosLinks && videosLinks.length > 0 ? videosLinks : [{ label: "", url: "" }]);
	const submitVideosValues = debounce(setVideosValues, 700);

	const handleChange = (video, id) => {
		let list = videos.map((v, i) => (i === id ? video : v));
		setVideos(list);
		submitVideosValues(list);
	};
	const removeVideoFromList = (id) => {
		let list = videos.filter((v, i) => i !== id);
		setVideos(list);
		submitVideosValues(list);
	};

	return (
		<div>
			<Table celled striped>
				<Table.Body>
					{videos &&
						videos.map((v, i) => (
							<VideoLink key={`video${i}`} video={v} id={i} listHandleChange={handleChange} removeVideoFromList={removeVideoFromList} />
						))}
				</Table.Body>
			</Table>
			<Button
				icon="plus"
				content=""
				onClick={() => {
					videos.push({ label: "", url: "" });
					setVideos(videos);
				}}
			/>
		</div>
	);
};
export default VideosLinksForm;

const VideoLink = ({ video, id, listHandleChange, removeVideoFromList }) => {
	const handleChange = (e, { name, value, id }) => {
		video[name] = value;
		listHandleChange(video, id);
	};
	return (
		<Table.Row>
			<Table.Cell collapsing>
				<Form.Input placeholder="Texte du lien" id={id} name="label" value={video.label} onChange={handleChange} />
			</Table.Cell>
			<Table.Cell>
				<Form.Input placeholder="Url du lien" id={id} name="url" value={video.url} onChange={handleChange} style={{ width: "100%" }} />
			</Table.Cell>
			<Table.Cell collapsing textAlign="right">
				<Form.Button
					style={{ padding: "0.5em" }}
					icon="minus"
					content=""
					onClick={() => {
						removeVideoFromList(id);
					}}
				/>
			</Table.Cell>
		</Table.Row>
	);
};
